export const numberFormat = new Intl.NumberFormat("vn", {
  style: "decimal",
  currency: "VND"
})
